import { useNavigate } from "react-router-dom";
import styles from "./informacoes.module.css";
import {AuthContext} from "../../context/AuthContext";
import { useContext } from "react";
import BottomNav from "../../components/BottomNav";

export default function Informacoes() {
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);

    const menus = [
        {
            titulo: "Holerite",
            descricao: "Consulta de contracheques",
            icone: "📄",
            rota: "/informacoes/holerite",
            permissoes: ["F"]
        },
        {
            titulo: "Vale Adiantamento",
            descricao: "Consulta adiantamneto",
            icone: "💰",
            rota: "/informacoes/vale",
            permissoes: ["F"]
        },
        {
            titulo: "PLR",
            descricao: "Participação nos lucros",
            icone: "🏆",
            rota: "/informacoes/plr",
            permissoes: ["F", "T"]
        },
        {
            titulo: "Controle Financeiro",
            descricao: "Resumo financeiro pessoal",
            icone: "📊",
            rota: "/informacoes/controle",
            permissoes: ["T"]
        }
    ];

    const menusFiltrados = menus.filter(menu =>
        menu.permissoes.includes(user.tipfun)
    );

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.headerIcon}>💼</div>
                <div className={styles.headerTexto}>
                    <h2>Informações</h2>
                    <p>Acesse suas informações financeiras</p>
                </div>
            </div>

            <div className={styles.grid}>
                {menusFiltrados.map((item, index) => (
                    <div
                        key={index}
                        className={styles.card}
                        onClick={() => navigate(item.rota)}
                    >
                        <div className={styles.icon}>{item.icone}</div>

                        <div className={styles.info}>
                            <h4>{item.titulo}</h4>
                            <span>{item.descricao}</span>
                        </div>

                        <div className={styles.arrow}>›</div>
                    </div>
                ))}
            </div>
            <BottomNav/>
        </div>
    );
}
